import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: the intents the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: they trigger side effects, not state transitions
 * (the saga owns the resulting `load*` and `mutation*` transitions).
 */

/** Load every list (dispatched by the page on mount). */
export const listsRequested = createAction('lists/listsRequested');

/** Load the licences the transfer picker offers. Admin-gated at the call site. */
export const licencesRequested = createAction('lists/licencesRequested');

/** Rename one list. The name is trimmed by the saga before it is sent. */
export const renameRequested = createAction<{ id: string; name: string }>('lists/renameRequested');

/**
 * Hand one list to another licence.
 *
 * `licenceId` is never the list's current one: the dialog refuses a transfer to
 * where the list already is, and the API would read the echoed value as a real
 * transfer, which a non-admin is refused outright.
 */
export const transferRequested = createAction<{ id: string; name: string; licenceId: string }>(
  'lists/transferRequested',
);

/** Copy one list, memberships included, under the given name. */
export const duplicateRequested = createAction<{ id: string; name: string }>(
  'lists/duplicateRequested',
);

/** Delete one list, permanently. */
export const deleteRequested = createAction<{ id: string; name: string }>('lists/deleteRequested');
